import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Confirmation</ModalHeader>
      <ModalBody>Are you sure you want to delete this item?</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          No
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DeleteConfirmationModal
